var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3189 1.98278C17.3362 0.236273 19.8593 0.236269 20.8766 1.98277L25.1137 9.25755C25.4864 9.89733 26.1108 10.351 26.8344 10.5077L35.0625 12.2895C37.0378 12.7172 37.8175 15.1168 36.4709 16.624L30.8615 22.9018C30.3682 23.4539 30.1297 24.188 30.2043 24.9246L31.0523 33.3006C31.2559 35.3114 29.2147 36.7945 27.3651 35.9795L19.6612 32.5846C18.9837 32.286 18.2118 32.286 17.5343 32.5846L9.83036 35.9795C7.98082 36.7945 5.93958 35.3114 6.14318 33.3006L6.99124 24.9246C7.06582 24.188 6.82732 23.4539 6.334 22.9018L0.724639 16.624C-0.622039 15.1168 0.157642 12.7172 2.13301 12.2895L10.3611 10.5077C11.0847 10.351 11.7091 9.89733 12.0818 9.25755L16.3189 1.98278Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillStar);
export default __webpack_public_path__ + "static/media/fill-star.5bef69271111ce8d1ada75eda0b64235.svg";
export { ForwardRef as ReactComponent };